import { sisikong_url } from "../../../api";

export const baseUrl = `${sisikong_url}/sophon-evo`;
// export const baseUrl = `http://localhost:8888/sophon-evo`;
